export type PromosOnbackModalAction = {
  type: "ONBACK_PROMOS_MODAL";
  payload: boolean;
};

export const onbackPromosModal = (
  isPromoCardsModalOpen: boolean
): PromosOnbackModalAction => ({
  type: "ONBACK_PROMOS_MODAL",
  payload: isPromoCardsModalOpen
});
